import { render, staticRenderFns } from "./SettingForm.vue?vue&type=template&id=0cf3daca&scoped=true&"
import script from "./SettingForm.vue?vue&type=script&lang=js&"
export * from "./SettingForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingForm.vue?vue&type=style&index=0&id=0cf3daca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf3daca",
  null
  
)

export default component.exports